exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img-uploader .el-upload[data-v-5e12fcf6]{cursor:pointer;position:relative;overflow:hidden}.img-uploader .img-uploader-icon[data-v-5e12fcf6]{font-size:28px;border:1px dashed #e6e6e6;border-radius:6px;color:#8c939d;text-align:center;width:100px;height:100px;line-height:100px}.img-uploader .img-uploader-img[data-v-5e12fcf6]{width:100px;height:100px}\n", ""]);

// exports
